<template>
<div class="app">
    <v-navigation-drawer persistent :mini-variant="miniVariant" width="245" :clipped="clipped" v-model="drawer" enable-resize-watcher fixed="" app>
        <v-list dense>
            <template>
                <v-list-tile href="/#/coper/clinista/isteklistesi">
                    <v-list-tile-action>
                        <v-icon>home</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>
                            İstek Listesi
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile href="/#/coper/clinista/clinistatakvim">
                    <v-list-tile-action>
                        <v-icon>event_note</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>
                            {{ $t('Calendar') }}
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-list-tile @click="logout()">
                    <v-list-tile-action>
                        <v-icon>power_settings_new</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-title> &nbsp;{{$t('Log-Out')}}</v-list-tile-title>
                </v-list-tile>
            </template>
        </v-list>

    </v-navigation-drawer>
    <v-toolbar color="info" dark app :clipped-left="$vuetify.breakpoint.mdAndUp" fixed>
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
            İstek Detay
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <!-- <v-btn icon>
                    <v-icon>notifications</v-icon>
                </v-btn> -->

    </v-toolbar>
    <v-content>
        <v-card color="grey lighten-5" flat>
            <v-flex pa-3 xs12 sm12 md12>
                <v-layout row wrap>

                    <v-flex xs12 sm7 md12>
                        <v-form ref="formsacekim" v-model="validform" lazy-validation>

                            <v-card flat style="min-height:450px">
                                <v-layout row wrap>
                                    <v-flex pa-1 xs12 sm6 md6>
                                        <v-carousel @click.native="gorseldetay=true" cycle height="450" hide-delimiter-background show-arrows-on-hover>
                                            <v-carousel-item v-for="(item,i) in istekBilgileri.ImageUrl" :key="i" :src="item.Url">
                                            </v-carousel-item>
                                        </v-carousel>
                                    </v-flex>

                                    <v-flex pa-1 xs12 sm12 md6>
                                        <v-layout row wrap>
                                            <v-flex xs12 pb-2 sm12 md12>
                                                <v-layout row wrap class=" project overdue">
                                                    <v-toolbar flat="" size="120px" dark color="white">
                                                        <v-toolbar-title>
                                                            <span class="title black--text font-weight-">
                                                                {{istekBilgileri.Name}} {{istekBilgileri.LastName}} -
                                                                {{istekBilgileri.BirthDate | dateformat}}
                                                            </span>
                                                        </v-toolbar-title>
                                                        <v-spacer></v-spacer>
                                                    </v-toolbar>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 sm12 md4>
                                                <v-select :rules="[v => !!v || $t('Mandatory-Areas')]" v-show="istekBilgileri.RequestType !=2 && istekBilgileri.RequestType == 0" label="Standart Fiyat" :disabled="fiyattip" @change="onChange($event)" v-model="RequestUpdate.RequestType" :items="fiyattipiitems" color="grey darken-1" item-text="text" item-value="value">
                                                </v-select>
                                                <v-select :rules="[v => !!v || $t('Mandatory-Areas')]" v-show="istekBilgileri.RequestType == 2" label="Saç Tutmaz" :disabled="fiyattip" v-model="RequestUpdate.RequestType">
                                                </v-select>
                                                <v-select :rules="[v => !!v || $t('Mandatory-Areas')]" v-show="istekBilgileri.RequestType == 1" label="Özel Fiyat" :disabled="fiyattip" v-model="RequestUpdate.RequestType">
                                                </v-select>

                                            </v-flex>
                                            <v-flex xs12 sm12 md4>
                                                <v-select :rules="[v => !!v || $t('Mandatory-Areas')]" v-if="this.Status == 0" label="Kur Seçiniz:" v-model="RequestUpdate.RequestCurrency" :disabled="RequestUpdate.RequestType==0  || RequestUpdate.RequestType==2" :items="kurtipiitems" color="grey darken-1" item-text="text" item-value="value"></v-select>
                                                <v-select :rules="[v => !!v || $t('Mandatory-Areas')]" v-else label="Kur Seçiniz:" v-model="RequestUpdate.RequestCurrency" :disabled="fiyattip" :items="kurtipiitems" color="grey darken-1" item-text="text" item-value="value"></v-select>
                                            </v-flex>
                                            <v-flex xs12 sm12 md4>

                                                <parainput :rules="[v => !!v || $t('Mandatory-Areas')]" v-if="this.Status == 0" :simge="''" :etiket="'Tutar Giriniz'" :aktif="RequestUpdate.RequestType==0  || RequestUpdate.RequestType==2" v-model="RequestUpdate.RequestPrice" :autocomplete="'autocomplete'">
                                                </parainput>
                                                <parainput :rules="[v => !!v || $t('Mandatory-Areas')]" v-else :simge="''" :etiket="'Tutar Giriniz'" :aktif="fiyattip" v-model="RequestUpdate.RequestPrice" :autocomplete="'autocomplete'">
                                                </parainput>
                                            </v-flex>

                                            <v-flex xs12 sm12 md12>
                                                <v-textarea :rules="[v => !!v || $t('Mandatory-Areas')]" :disabled="fiyattip" label="Teşhis Açıklama" v-model="RequestUpdate.StatusMessage">
                                                </v-textarea>
                                            </v-flex>
                                            <v-flex v-if="Status == 0" xs12 sm12 md9>
                                                <v-btn block color="info" @click="IstekUpdate()">Teklif Ver
                                                </v-btn>
                                            </v-flex>
                                            <v-flex xs12 sm12 md3>
                                                <v-btn color="info" @click="DownloadImage()">Fotoğrafları İndir
                                                </v-btn>
                                            </v-flex>

                                            <v-flex v-if="ImageCount >= 4 " xs12 sm12 md12>

                                                <v-item-group>
                                                    <v-container>
                                                        <v-layout wrap>
                                                            <v-flex xs4 md2>
                                                                <v-item>
                                                                    <v-card slot-scope="{ active, toggle }" :color="active ? 'primary' : ''" class="d-flex align-center" dark height="75" width="75" @click="toggle">
                                                                        <v-scroll-y-transition>
                                                                            <v-btn v-if="photoStatus" flat fab @click="addFiles()">
                                                                                <v-icon color="info">add_a_photo</v-icon>
                                                                            </v-btn>
                                                                            <v-btn v-else flat fab @click="addFiles()">
                                                                                <v-icon color="info">check</v-icon>
                                                                            </v-btn>
                                                                        </v-scroll-y-transition>
                                                                    </v-card>
                                                                </v-item>
                                                            </v-flex>
                                                            <v-flex pl-1 xs4 md2>
                                                                <v-item>
                                                                    <v-card slot-scope="{ active, toggle }" :color="active ? 'primary' : ''" class="d-flex align-center" dark height="75" width="75" @click="toggle">
                                                                        <v-scroll-y-transition>
                                                                            <v-btn v-if="photoStatustwo" flat fab @click="addFiles2()">
                                                                                <v-icon color="info">add_a_photo</v-icon>
                                                                            </v-btn>
                                                                            <v-btn v-else flat fab @click="addFiles2()">
                                                                                <v-icon color="info">check</v-icon>
                                                                            </v-btn>
                                                                        </v-scroll-y-transition>
                                                                    </v-card>
                                                                </v-item>
                                                            </v-flex>
                                                            <v-flex pl-1 xs4 md2>
                                                                <v-item>
                                                                    <v-card slot-scope="{ active, toggle }" :color="active ? 'primary' : ''" class="d-flex align-center" dark height="75" width="75" @click="toggle">
                                                                        <v-scroll-y-transition>
                                                                            <v-btn flat v-if="photoStatusthree" fab @click="addFiles3()">
                                                                                <v-icon color="info">add_a_photo</v-icon>
                                                                            </v-btn>
                                                                            <v-btn flat v-else fab @click="addFiles3()">
                                                                                <v-icon color="info">check</v-icon>
                                                                            </v-btn>
                                                                        </v-scroll-y-transition>
                                                                    </v-card>
                                                                </v-item>
                                                            </v-flex>
                                                            <v-flex pl-1 xs4 md2>
                                                                <v-item>
                                                                    <v-card slot-scope="{ active, toggle }" :color="active ? 'primary' : ''" class="d-flex align-center" dark height="75" width="75" @click="toggle">
                                                                        <v-scroll-y-transition>
                                                                            <v-btn flat v-if="photoStatusfour" fab @click="addFiles4()">
                                                                                <v-icon color="info">add_a_photo</v-icon>
                                                                            </v-btn>
                                                                            <v-btn flat v-else fab @click="addFiles4()">
                                                                                <v-icon color="info">check</v-icon>
                                                                            </v-btn>
                                                                        </v-scroll-y-transition>
                                                                    </v-card>
                                                                </v-item>
                                                            </v-flex>
                                                            <v-flex pl-1 pt-3 xs4 md2>
                                                                <v-btn color="info" @click="DosyalariYukle()">
                                                                    Fotoğrafları Yükle
                                                                </v-btn>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-container>
                                                </v-item-group>

                                                <v-form ref="formaktarim" id="formaktarim" method="post" enctype="multipart/form-data" v-model="valid" lazy-validation>
                                                    <input hidden :rules="[v => !!v || $t('Mandatory-Areas')]" type="file" id="file" ref="file" multiple v-on:change="handleFileUpload()" />
                                                </v-form>

                                                <v-form ref="formaktarimtwo" id="formaktarimtwo" method="post" enctype="multipart/form-data" v-model="valid" lazy-validation>
                                                    <input hidden :rules="[v => !!v || $t('Mandatory-Areas')]" type="file" id="filetwo" ref="filetwo" multiple v-on:change="handleFileUpload2()" />
                                                </v-form>

                                                <v-form ref="formaktarimthree" id="formaktarimthree" method="post" enctype="multipart/form-data" v-model="valid" lazy-validation>
                                                    <input hidden :rules="[v => !!v || $t('Mandatory-Areas')]" type="file" id="filethree" ref="filethree" multiple v-on:change="handleFileUpload3()" />
                                                </v-form>

                                                <v-form ref="formaktarimfour" id="formaktarimfour" method="post" enctype="multipart/form-data" v-model="valid" lazy-validation>
                                                    <input hidden :rules="[v => !!v || $t('Mandatory-Areas')]" type="file" id="filefour" ref="filefour" multiple v-on:change="handleFileUpload4()" />
                                                </v-form>
                                                <!--
                                        <v-btn flat :loading="false" :disabled="false" color="info" @click="addFiles()">
                                            <v-icon color="info" left>add_a_photo</v-icon>3 Adet Fotoğraf Seçiniz
                                        </v-btn>
                                         -->

                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>

                                <v-layout row wrap>
                                    <v-flex pa-3 xs12 sm5 md12>
                                        <v-layout row wrap>
                                            <v-flex xs12 pt-2 pb-2 sm12 md12>
                                                <v-layout row wrap class=" project overdue">
                                                    <v-toolbar flat="" size="120px" dark color="white">
                                                        <v-toolbar-title>
                                                            <span class="title black--text font-weight-">
                                                                Hasta Detay Bilgileri
                                                            </span>
                                                        </v-toolbar-title>
                                                        <v-spacer></v-spacer>
                                                        <!-- <v-btn color="green" @click="Rezgonder()">Rezervasyon Yap
                                                </v-btn> -->
                                                    </v-toolbar>
                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 sm12 md6>
                                                <v-layout row wrap>

                                                    <v-flex xs12 pb-1 sm12 md12>
                                                        <v-layout row wrap>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">live_help</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                <span class="subheading">
                                                                    Sürekli kullandığınız bir ilaç var mı?
                                                                </span>
                                                            </v-flex>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">remove</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                {{istekBilgileri.AlwaysMedicine}}
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>

                                                    <v-flex xs12 pb-1 sm12 md12>
                                                        <v-layout row wrap>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">live_help</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                <span class="subheading">
                                                                    Bu zamana
                                                                    kadar saç dökülmesi için tedavi aldınız mı? </span>
                                                            </v-flex>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">remove</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                {{istekBilgileri.GetTherapy}}
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>

                                                    <v-flex xs12 pb-1 sm12 md12>
                                                        <v-layout row wrap>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">live_help</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                <span class="subheading">
                                                                    Saçınızın en
                                                                    çok döküldüğü bölümden 1 tutam saçı dibinden hafifçe tutarak
                                                                    yukarıya doğru çekin. Kaç adet saç teli geldi?</span>
                                                            </v-flex>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">remove</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                {{istekBilgileri.HairLossCount}}
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>

                                                    <v-flex xs12 pb-1 sm12 md12>
                                                        <v-layout row wrap>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">live_help</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                <span class="subheading">
                                                                    Son 6 ay
                                                                    içinde 5 kilo veya daha fazlasını verdiniz mi?</span>
                                                            </v-flex>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">remove</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                {{istekBilgileri.LoosFiveKg}}
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>

                                                    <v-flex xs12 pb-1 sm12 md12>
                                                        <v-layout row wrap>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">live_help</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                <span class="subheading">
                                                                    Son 6 ay
                                                                    içinde büyük bir cerrahi operasyon geçirdiniz mi?</span>
                                                            </v-flex>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">remove</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                {{istekBilgileri.SurgicalOperation}}
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>

                                                    <v-flex xs12 pb-1 sm12 md12>
                                                        <v-layout row wrap>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">live_help</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                <span class="subheading">
                                                                    Banyo veya
                                                                    duş sırasında saçlarınızın çok döküldüğüne şahit olur
                                                                    musunuz?</span>
                                                            </v-flex>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">remove</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                {{istekBilgileri.ShowerHairLoss}}
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>

                                                    <v-flex xs12 pb-1 sm12 md12>
                                                        <v-layout row wrap>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">live_help</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                <span class="subheading">
                                                                    Saçlarınızın
                                                                    sürekli döküldüğünü düşünüyor musunuz?</span>
                                                            </v-flex>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">remove</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                {{istekBilgileri.AlwaysHairLoss}}
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>

                                                    <v-flex xs12 pb-1 sm12 md12>
                                                        <v-layout row wrap>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">live_help</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                <span class="subheading">
                                                                    Ketojenik
                                                                    diyet, dukan diyeti gibi sıkı diyetler yapıyor musunuz?</span>
                                                            </v-flex>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">remove</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                {{istekBilgileri.Diet}}
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>

                                                    <v-flex xs12 pb-1 sm12 md12>
                                                        <v-layout row wrap>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">live_help</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                <span class="subheading">
                                                                    Kafa
                                                                    derinizde yanma, kaşıntı, kızarıklık var mı?</span>
                                                            </v-flex>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">remove</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                {{istekBilgileri.HairBurning}}
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>

                                                    <v-flex xs12 pb-1 sm12 md12>
                                                        <v-layout row wrap>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">live_help</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                <span class="subheading">
                                                                    Son 6 ay
                                                                    içinde tam kan sayımı veya check-up yaptırdınız mı?</span>
                                                            </v-flex>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">remove</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                {{istekBilgileri.CheckUp}}
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>

                                                    <v-flex xs12 pb-1 sm12 md12>
                                                        <v-layout row wrap>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">live_help</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                <span class="subheading">
                                                                    Tiroid
                                                                    rahatsızlığınız var mı?</span>
                                                            </v-flex>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">remove</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                {{istekBilgileri.Tiroid}}
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>

                                                    <v-flex xs12 pb-1 sm12 md12>
                                                        <v-layout row wrap>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">live_help</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                <span class="subheading">
                                                                    Saç
                                                                    tellerinizin kalınlığı nasıldır?</span>
                                                            </v-flex>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">remove</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                {{istekBilgileri.HairThickness}}
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>

                                                </v-layout>
                                            </v-flex>

                                            <v-flex xs12 sm12 md6>
                                                <v-layout row wrap>

                                                    <v-flex xs12 pb-1 sm12 md12>
                                                        <v-layout row wrap>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">live_help</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                <span class="subheading">
                                                                    Menstrual
                                                                    döngünüzde bir sorun var mı? Son 6 ay içinde doğum yaptınız
                                                                    mı? </span>
                                                            </v-flex>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">remove</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                {{istekBilgileri.Menstrual}}
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>

                                                    <v-flex xs12 pb-1 sm12 md12>
                                                        <v-layout row wrap>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">live_help</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                <span class="subheading">
                                                                    Eklemek
                                                                    istenilen not</span>
                                                            </v-flex>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">remove</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                {{istekBilgileri.RequestNote}}
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>

                                                    <v-flex xs12 pb-1 sm12 md12>
                                                        <v-layout row wrap>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">live_help</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                <span class="subheading">
                                                                    Saç
                                                                    dökülmeniz lokal bir bölgede mi tüm kafa derisinde yaygın mı
                                                                    görülmektedir?</span>
                                                            </v-flex>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">remove</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                {{istekBilgileri.LocalOrGeneral}}
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12 pb-1 sm12 md12>
                                                        <v-layout row wrap>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">live_help</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                <span class="subheading">
                                                                    Saç
                                                                    dökülmeniz ne zamandır devam ediyor ?</span>
                                                            </v-flex>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">remove</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                {{istekBilgileri.HairLossTime}}
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12 pb-1 sm12 md12>
                                                        <v-layout row wrap>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">live_help</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                <span class="subheading">
                                                                    B12
                                                                    Eksikliği tanısı ile ilaç kullanıyor musunuz?</span>
                                                            </v-flex>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">remove</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                {{istekBilgileri.VitaminLoss}}
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>
                                                    <v-flex xs12 pb-1 sm12 md12>
                                                        <v-layout row wrap>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">live_help</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                <span class="subheading">
                                                                    Kemoterapi
                                                                    gördünüz mü?</span>
                                                            </v-flex>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">remove</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                {{istekBilgileri.Chemotherapy}}
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>

                                                    <v-flex xs12 pb-1 sm12 md12>
                                                        <v-layout row wrap>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">live_help</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                <span class="subheading">
                                                                    Diyabetiniz
                                                                    var mı?</span>
                                                            </v-flex>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">remove</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                {{istekBilgileri.Diabetes}}
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>

                                                    <v-flex xs12 pb-1 sm12 md12>
                                                        <v-layout row wrap>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">live_help</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                <span class="subheading">
                                                                    Hiç demir
                                                                    eksikliği tanısı ile ilaç kullandınız mı?</span>
                                                            </v-flex>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">remove</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                {{istekBilgileri.IronLoss}}
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>

                                                    <v-flex xs12 pb-1 sm12 md12>
                                                        <v-layout row wrap>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">live_help</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                <span class="subheading">
                                                                    Ailenizde
                                                                    saç dökülmesi sorunu var mı?</span>
                                                            </v-flex>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">remove</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                {{istekBilgileri.FamilyHairLoss}}
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>

                                                    <v-flex xs12 pb-1 sm12 md12>
                                                        <v-layout row wrap>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">live_help</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                <span class="subheading">
                                                                    Vejeteryan
                                                                    mısınız?</span>
                                                            </v-flex>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">remove</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                {{istekBilgileri.Vegetarian}}
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>

                                                    <v-flex xs12 pb-1 sm12 md12>
                                                        <v-layout row wrap>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">live_help</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                <span class="subheading">
                                                                    Doğal saç
                                                                    renginiz nedir?</span>
                                                            </v-flex>
                                                            <v-flex xs12 sm1 md1>
                                                                <v-icon color="grey">remove</v-icon>
                                                            </v-flex>
                                                            <v-flex xs12 sm11 md11>
                                                                {{istekBilgileri.HairColor}}
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>

                                                </v-layout>
                                            </v-flex>
                                        </v-layout>

                                    </v-flex>
                                </v-layout>

                            </v-card>

                        </v-form>

                    </v-flex>

                </v-layout>
            </v-flex>
        </v-card>
    </v-content>
    <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
    </v-snackbar>

    <v-dialog v-model="gorseldetay" v-if="gorseldetay" scrollable="" persistent="" max-height="900px" max-width="900px">
        <v-card>
            <v-card-title>Hasta Fotoğraf Detayı</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-layout row wrap="">
                    <v-flex xs12 sm12 md12>
                        <v-card flat class="white--text">
                            <v-card flat="">
                                <v-card-actions>
                                    <v-layout row wrap>
                                        <v-flex xs12 sm12 md12>
                                            <v-carousel height="450" hide-delimiter-background show-arrows-on-hover>
                                                <v-carousel-item v-for="(item,i) in istekBilgileri.ImageUrl" :key="i" :src="item.Url">
                                                </v-carousel-item>
                                            </v-carousel>
                                        </v-flex>
                                    </v-layout>
                                </v-card-actions>
                            </v-card>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="gorseldetay=false">{{$t('Close')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
import auth from "@/api/auth.js"
import axios from 'axios'
import helpers from "@/components/app/customcomp/helpers.js"
import tarihcomp from "@/components/app/customcomp/tarihim.vue"
import parainput from '@/components/app/customcomp/parainput.vue'

export default {
    data() {
        return {
            rules: {
                required: (value) => !!value || this.$t('Mandatory-Areas'),
            },
            istekBilgileri: {},
            ImageCount:0,
            photoStatus: true,
            photoStatustwo: true,
            photoStatusthree: true,
            photoStatusfour: true,
            cancelPhoto: false,
            fiyattip: true,
            Status: null,
            validform: true,
            valid: true,
            gorseldetay: false,
            clipped: true,
            drawer: true,
            fixed: false,
            miniVariant: false,
            right: true,
            text1: '',
            snackbar: false,
            loading: false,
            dosyayolu1: null,
            secilenSayi: 0,
            file: [],
            secilendosya: null,
            el: null,
            y: 'top',
            x: 'right',
            mode: '',
            timeout: 6000,
            RequestUpdate: {
                RequestID: null,
                Status: 1,
                RequestType: null,
                RequestPrice: null,
                StatusMessage: null,
                RequestCurrency: null,
                DoctorID: null
            },
            kurtipiitems: [{
                text: 'TRY',
                value: 'TRY'
            }, {
                text: 'EUR',
                value: 'EUR'
            }, {
                text: 'USD',
                value: 'USD'
            }],
            fiyattipiitems: [{
                text: 'Standart Fiyat',
                value: '0'
            }, {
                text: 'Özel Fiyat',
                value: '1'
            }, {
                text: 'Saç Tutmaz',
                value: '2'
            }],
        }
    },
    components: {
        tarihcomp,
        parainput
    },
    beforeMount: beforeMount,
    methods: {
        addFiles() {
            this.$refs.file.click();

        },
        addFiles2() {
            this.$refs.filetwo.click();

        },
        addFiles3() {
            this.$refs.filethree.click();

        },
        addFiles4() {
            this.$refs.filefour.click();

        },
        handleFileUpload() {
            //this.file = []
            if (this.secilenSayi >= 4) {
                this.text1 = "Maksimum 4 Adet fotoğraf yükleyebilirsiniz."
                this.snackbar = true
            } else {

                if (this.$refs.file.files.length > 1) {
                    this.text1 = "Lütfen Her Defasında Bir Adet Fotoğraf Seçiniz."
                    this.snackbar = true
                } else {

                    if (this.$refs.file.files != [] && this.$refs.file.files != null) {
                        this.cancelPhoto = true

                        var uploadedFiles = this.$refs.file.files;

                        var fp = document.getElementById('file');

                        var lg = uploadedFiles.length; // get length

                        //document.getElementById('ulList').innerHTML = '';

                        var items = uploadedFiles
                        var fragment = "";

                        if (lg > 0) {
                            for (var i = 0; i < lg; i++) {
                                var fileName = "d" + escape(items[i].name); // get file name
                                var fileSize = items[i].size; // get file size
                                var fileType = items[i].type; // get file type

                                if (fileType === "image/png" || fileType === "image/jpeg") {
                                    fragment += "<li>" + fileName + " (<b>" + fileSize +
                                        "</b> bytes)"
                                    this.secilenSayi += 1
                                } else {
                                    this.text1 = "Dosya Uzantısını kontrol ediniz. Sadece png ve jpg eklenebilir."
                                    this.snackbar = true
                                    this.secilenSayi = this.secilenSayi - 1

                                }

                            }
                            // document.getElementById('ulList').innerHTML = fragment;

                        }

                        if (this.secilenSayi >= 1) {
                            this.dosya1mesaj = this.secilenSayi +  " " + this.$t('pcs-of-files-selected')
                            this.photoStatus = false

                        } else {
                            this.dosya1mesaj = this.$t('file-has-been-chosen')
                        }

                        if (uploadedFiles.length > 0) {

                            for (var i = 0; i < uploadedFiles.length; i++) {

                                this.file.push(uploadedFiles[i]);
                            }

                        } else {

                        }
                    }
                }
            }

        },
        handleFileUpload2() {
            //this.file = []

            if (this.secilenSayi >= 4) {
                this.text1 = "Maksimum 4 Adet fotoğraf yükleyebilirsiniz."
                this.snackbar = true
            } else {
                if (this.$refs.filetwo.files.length > 1) {
                    this.text1 = "Lütfen Her Defasında Bir Adet Fotoğraf Seçiniz."
                    this.snackbar = true
                } else {

                    if (this.$refs.filetwo.files != [] && this.$refs.filetwo.files != null) {
                        this.cancelPhoto = true

                        var uploadedFiles = this.$refs.filetwo.files;

                        var fp = document.getElementById('filetwo');

                        var lg = uploadedFiles.length; // get length

                        // document.getElementById('ulList').innerHTML = '';

                        var items = uploadedFiles
                        //var fragment = document.getElementById('ulList').innerText
                        var fragment = "";
                        if (lg > 0) {
                            for (var i = 0; i < lg; i++) {
                                var fileName = "d" + escape(items[i].name); // get file name
                                var fileSize = items[i].size; // get file size
                                var fileType = items[i].type; // get file type

                                if (fileType === "image/png" || fileType === "image/jpeg") {
                                    fragment += "<li>" + fileName + " (<b>" + fileSize +
                                        "</b> bytes)"
                                    this.secilenSayi += 1

                                } else {
                                    this.text1 = "Dosya Uzantısını kontrol ediniz. Sadece png ve jpg eklenebilir."
                                    this.snackbar = true
                                    this.secilenSayi = this.secilenSayi - 1

                                }

                            }
                            // document.getElementById('ulList').innerHTML = fragment;

                        }

                        if (this.secilenSayi >= 1) {
                            this.dosya1mesaj = this.secilenSayi +  " " + this.$t('pcs-of-files-selected')
                            this.photoStatustwo = false

                        } else {
                            this.dosya1mesaj = this.$t('file-has-been-chosen')
                        }

                        if (uploadedFiles.length > 0) {

                            for (var i = 0; i < uploadedFiles.length; i++) {

                                this.file.push(uploadedFiles[i]);
                            }

                        } else {

                        }
                    }
                }
            }

        },
        handleFileUpload3() {
            //this.file = []

            if (this.secilenSayi >= 4) {
                this.text1 = "Maksimum 4 Adet fotoğraf yükleyebilirsiniz."
                this.snackbar = true
            } else {
                if (this.$refs.filetwo.files.length > 1) {
                    this.text1 = "Lütfen Her Defasında Bir Adet Fotoğraf Seçiniz."
                    this.snackbar = true
                } else {

                    if (this.$refs.filethree.files != [] && this.$refs.filethree.files != null) {
                        this.cancelPhoto = true

                        var uploadedFiles = this.$refs.filethree.files;

                        var fp = document.getElementById('filethree');

                        var lg = uploadedFiles.length; // get length

                        //document.getElementById('ulList').innerHTML = '';

                        var items = uploadedFiles
                        var fragment = "";

                        if (lg > 0) {
                            for (var i = 0; i < lg; i++) {
                                var fileName = "d" + escape(items[i].name); // get file name
                                var fileSize = items[i].size; // get file size
                                var fileType = items[i].type; // get file type

                                if (fileType === "image/png" || fileType === "image/jpeg") {
                                    fragment += "<li>" + fileName + " (<b>" + fileSize +
                                        "</b> bytes)"
                                    this.secilenSayi += 1

                                } else {
                                    this.text1 = "Dosya Uzantısını kontrol ediniz. Sadece png ve jpg eklenebilir."
                                    this.snackbar = true
                                    this.secilenSayi = this.secilenSayi - 1

                                }

                            }
                            //document.getElementById('ulList').innerHTML = fragment;

                        }

                        if (this.secilenSayi >= 1) {
                            this.dosya1mesaj = this.secilenSayi + " " + this.$t('pcs-of-files-selected')
                            this.photoStatusthree = false

                        } else {
                            this.dosya1mesaj = this.$t('file-has-been-chosen')
                        }

                        if (uploadedFiles.length > 0) {

                            for (var i = 0; i < uploadedFiles.length; i++) {

                                this.file.push(uploadedFiles[i]);
                            }

                        } else {

                        }
                    }
                }
            }
        },
        handleFileUpload4() {
            //this.file = []

            if (this.secilenSayi >= 4) {
                this.text1 = "Maksimum 4 Adet fotoğraf yükleyebilirsiniz."
                this.snackbar = true
            } else {
                if (this.$refs.filefour.files.length > 1) {
                    this.text1 = "Lütfen Her Defasında Bir Adet Fotoğraf Seçiniz."
                    this.snackbar = true
                } else {

                    if (this.$refs.filefour.files != [] && this.$refs.filefour.files != null) {
                        this.cancelPhoto = true

                        var uploadedFiles = this.$refs.filefour.files;

                        var fp = document.getElementById('filefour');

                        var lg = uploadedFiles.length; // get length

                        //document.getElementById('ulList').innerHTML = '';

                        var items = uploadedFiles
                        var fragment = "";

                        if (lg > 0) {
                            for (var i = 0; i < lg; i++) {
                                var fileName = escape(items[i].name); // get file name
                                var fileSize = items[i].size; // get file size
                                var fileType = items[i].type; // get file type

                                if (fileType === "image/png" || fileType === "image/jpeg") {
                                    fragment += "<li>" + fileName + " (<b>" + fileSize +
                                        "</b> bytes)"
                                    this.secilenSayi += 1

                                } else {
                                    this.text1 = "Dosya Uzantısını kontrol ediniz. Sadece png ve jpg eklenebilir."
                                    this.snackbar = true
                                    this.secilenSayi = this.secilenSayi - 1

                                }

                            }
                            //document.getElementById('ulList').innerHTML = fragment;

                        }

                        if (this.secilenSayi >= 1) {
                            this.dosya1mesaj = this.secilenSayi +  " " + this.$t('pcs-of-files-selected')
                            this.photoStatusfour = false

                        } else {
                            this.dosya1mesaj = this.$t('file-has-been-chosen')
                        }

                        if (uploadedFiles.length > 0) {
                            for (var i = 0; i < uploadedFiles.length; i++) {
                                this.file.push(uploadedFiles[i]);
                            }

                        } else {

                        }
                    }
                }
            }
        },
        DosyalariYukle() {
            
            var ReqID = this.$route.query.RequestID
            var cred = JSON.parse(window.localStorage.getItem('credentials'));
            if (this.file.length > 0) {
                this.loadingvmodel = true
                let formData = new FormData();
                for (var i = 0; i < this.file.length; i++) {
                    let file = this.file[i];
                    formData.append('file[' + i + ']', file);
                    formData.append('RequestCode', ReqID)
                    axios.defaults.baseURL = auth.CLINISTA_API_URL;
                    axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
                    axios.post(auth.CLINISTA_API_URL + 'api/Clinista/DoctorFileUpload',
                            formData, {
                                headers: {
                                    'Authorization': 'Basic ' + window.btoa(auth.HOTELRUNNERUSERNAME + ':' + auth
                                        .HOTELRUNNERUSERPASS)
                                }
                            }
                        ).then((response) => {

                        })
                        .catch(function () {
                            this.loadingvmodel = false
                            this.text1 = this.$t('Error-in-file-transfer-try-again')
                            this.snackbar = true

                        });
                }
            }

        },
        ClearPhoto() {
            this.file = []
            this.$refs.file.files = null
            this.$refs.filetwo.files = null
            this.$refs.filethree.files = null
            this.photoStatus = true
            this.photoStatustwo = true
            this.photoStatusthree = true
            this.photoStatusfour = true
            this.secilenSayi = 0
        },
        logout() {
            auth.logout()
        },
        onChange(event) {
            if (event == 0) {
                this.RequestUpdate.RequestPrice = 1250
                this.RequestUpdate.RequestCurrency = "TRY"
            } else if (event == 1) {
                this.fiyattip = false
                this.RequestUpdate.RequestPrice = null
                this.$refs.formsacekim.resetValidation();

            } else if (event == 2) {

                this.fiyattip = false
                this.RequestUpdate.RequestPrice = null
                this.RequestUpdate.RequestCurrency = null
                this.$refs.formsacekim.resetValidation();
            }
        },
        DownloadImage() {

            for (var i = 0; i < this.istekBilgileri.ImageUrl.length; i++) {
                var file = this.istekBilgileri.ImageUrl[i].Url
                var filedetail = file.split('/')
                
            var params = {
                RequestID: this.$route.query.RequestID,
                FileName: filedetail[6] 
            }
            this.$http.post(auth.CLINISTA_API_URL + 'api/Clinista/FileDownload', params, {
                headers: {
                    'Authorization': 'Basic ' + window.btoa(auth.HOTELRUNNERUSERNAME + ':' + auth
                        .HOTELRUNNERUSERPASS)
                },
                responseType: 'arraybuffer'
            }).then((response) => {

                    const url = window.URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'file.png') //or any other extension
                    document.body.appendChild(link)
                    link.click()
                },(response) => {
                    this.text1 = "Hatalı Kayıt."
                    this.snackbar = true
                })
            }
            
        },
        IstekUpdate: IstekUpdate

    },
    filters: {
        dateformat: function (t) {
            return helpers.dateformat(t);
        },
    }
}

function beforeMount() {

    this.Status = this.$route.query.Status

    if (this.$route.query.Status == 0) {
        this.fiyattip = false
    }
    var params = {
        RequestID: this.$route.query.RequestID
    }

    this.$http.post(auth.CLINISTA_API_URL + 'api/Clinista/RequestLoad', params, {
        headers: {
            'Authorization': 'Basic ' + window.btoa(auth.HOTELRUNNERUSERNAME + ':' + auth
                .HOTELRUNNERUSERPASS)
        }
    }).then((response) => {
        this.istekBilgileri = response.body
        this.ImageCount = response.body.ImageUrl.length
        if (this.$route.query.Status != 0) {

            this.RequestUpdate.RequestPrice = this.istekBilgileri.RequestPrice
            if (this.istekBilgileri.RequestCurrency != "") {
                this.RequestUpdate.RequestCurrency = this.istekBilgileri.RequestCurrency
            }
            this.RequestUpdate.StatusMessage = this.istekBilgileri.StatusNote

        }
    }, (response) => {
        this.text1 = "Hatalı Kayıt."
        this.snackbar = true
    })

}

function IstekUpdate() {

    if (this.RequestUpdate.RequestType == 2) {

        var credentials = JSON.parse(window.localStorage.getItem('response'));

        this.RequestUpdate.DoctorID = credentials.UserId
        this.RequestUpdate.RequestID = this.$route.query.RequestID

        var params = this.RequestUpdate
        this.$http.post(auth.CLINISTA_API_URL + 'api/Clinista/RequestUpdate', params, {
            headers: {
                'Authorization': 'Basic ' + window.btoa(auth.HOTELRUNNERUSERNAME + ':' + auth
                    .HOTELRUNNERUSERPASS)
            }
        }).then((response) => {
            if (response.body.Status == true) {
                var url = '#/coper/clinista/isteklistesi';

                window.open(url, '_self')
            }
            if (response.body.Status == false) {
                this.text1 = response.body.ResponseMessage
                this.snackbar = true
            }
        }, (response) => {
            this.text1 = "Hatalı Kayıt."
            this.snackbar = true
        })

    } else {
        if (this.$refs.formsacekim.validate()) {

            var credentials = JSON.parse(window.localStorage.getItem('response'));

            this.RequestUpdate.DoctorID = credentials.UserId
            this.RequestUpdate.RequestID = this.$route.query.RequestID

            var params = this.RequestUpdate
            this.$http.post(auth.CLINISTA_API_URL + 'api/Clinista/RequestUpdate', params, {
                headers: {
                    'Authorization': 'Basic ' + window.btoa(auth.HOTELRUNNERUSERNAME + ':' + auth
                        .HOTELRUNNERUSERPASS)
                }
            }).then((response) => {
                if (response.body.Status == true) {
                    var url = '#/coper/clinista/isteklistesi';

                    window.open(url, '_self')
                }
                if (response.body.Status == false) {
                    this.text1 = response.body.ResponseMessage
                    this.snackbar = true
                }
            }, (response) => {
                this.text1 = "Hatalı Kayıt."
                this.snackbar = true
            })
        }
    }

}
</script>
